import React from 'react';
import { Switch, Route } from "react-router-dom";

import Discover from "../views/discover";
import UserMessages from "../views/user_messages";
// import Property from "../views/property_manage";
import UserProperty from "../views/user_property";
import UserPropertyEdit from "../views/user_property_edit";
import PropertyItem from "../views/property_item";
import Applicants from "../views/applicants";
import Login from "../views/login";
import Signup from "../views/signup";
import Account from "../views/account";
import Profile from "../views/profile";
import Notfound from "../views/404";
import Search from "../views/search";
import UserUpload from "../views/user_upload";
import UserConvo from "../views/user_convo";

const router = (
  <Switch>
    <Route exact path="/" component={Discover} />
    <Route exact path="/property" component={UserProperty} />
    <Route exact path="/property/new" component={UserUpload} />
    <Route exact path="/property/:id/message/:mid" component={UserConvo} />
    <Route exact path="/property/:id" component={PropertyItem} />
    <Route exact path="/inbox" component={UserMessages} />
    <Route exact path="/applicants" component={Applicants} />
    <Route exact path="/login" component={Login} />
    <Route exact path="/signup" component={Signup} />
    <Route exact path="/account" component={Account} />
    <Route exact path="/user/:id" component={Profile} />
    <Route exact path="/user/:id/property/:pid" component={UserPropertyEdit} />
    <Route path="/search" component={Search} />
    <Route component={Notfound} />
  </Switch>
)

export default router;